import React, { useState } from 'react';
import * as S from '../styles';

export default function BuscarTemplates({
  loading,
  consultaTemplatesLoading,
  consultaTemplatesForm,
  consultaTemplatesMessage,
  consultaTemplates,
  envioTemplateLoading,
  envioTemplateMessage,
  tokenAtivacaoDisponivel,
  testeEnvioConcluido,
  wabaIdSalvo,
  quantidadeParametrosEsperada,
  handleConsultaTemplatesField,
  buscarTodosTemplates,
  enviarTemplateSelecionado
}) {
  const [mostrarInfoTemplate, setMostrarInfoTemplate] = useState(false);

  const templateSelecionado = consultaTemplates.find((template) => {
    const key = `${template.name || ''}::${template.language || ''}`;
    return key === String(consultaTemplatesForm.selectedTemplateKey || '');
  });

  const paramsDigitadosBase = String(consultaTemplatesForm.bodyParams || '')
    .split('|')
    .map((item) => item.trim());

  const paramsFallbackOrder = [
    String(consultaTemplatesForm.orderNumber || '').trim(),
    String(consultaTemplatesForm.productName || '').trim(),
    String(consultaTemplatesForm.productQuantity || '').trim(),
    String(consultaTemplatesForm.orderTotalAmount || '').trim(),
    String(consultaTemplatesForm.orderReferenceId || '').trim()
  ].filter(Boolean);

  const paramsDigitados = [...paramsDigitadosBase.filter(Boolean)];
  while (paramsDigitados.length < Number(quantidadeParametrosEsperada || 0) && paramsFallbackOrder.length > 0) {
    paramsDigitados.push(paramsFallbackOrder.shift());
  }

  function substituirParametros(texto) {
    let cursorNomeado = 0;

    return String(texto || '').replace(/\{\{\s*([^{}]+?)\s*\}\}/g, (match, token) => {
      const marcador = String(token || '').trim();

      if (/^\d+$/.test(marcador)) {
        const index = Number(marcador) - 1;
        const valorNumerico = paramsDigitados[index];
        return valorNumerico ? `[${valorNumerico}]` : match;
      }

      const valorNomeado = paramsDigitados[cursorNomeado];
      cursorNomeado += 1;
      return valorNomeado ? `[${valorNomeado}]` : match;
    });
  }

  const componentesTemplate = Array.isArray(templateSelecionado?.components)
    ? templateSelecionado.components
    : [];

  const buttonsTemplate = componentesTemplate.find((item) => String(item?.type || '').toUpperCase() === 'BUTTONS');
  const hasOrderDetailsButton = Array.isArray(buttonsTemplate?.buttons)
    && buttonsTemplate.buttons.some((button) => String(button?.type || '').toUpperCase() === 'ORDER_DETAILS');

  const previewHeader = componentesTemplate.find((item) => String(item?.type || '').toUpperCase() === 'HEADER');
  const previewBody = componentesTemplate.find((item) => String(item?.type || '').toUpperCase() === 'BODY');
  const previewFooter = componentesTemplate.find((item) => String(item?.type || '').toUpperCase() === 'FOOTER');
  const previewBotaoTexto = String(buttonsTemplate?.buttons?.[0]?.text || 'Review and Pay');
  const previewHora = new Date().toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
  const previewHeaderText = substituirParametros(previewHeader?.text || '');
  const previewBodyText = substituirParametros(previewBody?.text || '');
  const previewFooterText = substituirParametros(previewFooter?.text || '');
  const previewTotalPedido = String(consultaTemplatesForm.orderTotalAmount || '').trim() || '--';
  const previewOrderNumber = String(consultaTemplatesForm.orderNumber || '').trim() || '{{Order number}}';
  const previewProductName = String(consultaTemplatesForm.productName || '').trim() || '{{Product name}}';
  const previewProductQuantity = String(consultaTemplatesForm.productQuantity || '').trim() || '{{#}}';
  const previewProductImagePublicUrl = String(consultaTemplatesForm.productImagePublicUrl || '').trim();
  const hasHeaderImageTemplate = String(previewHeader?.format || '').toUpperCase() === 'IMAGE';

  const bodyPreenchidos = paramsDigitados.length;
  const etapaConexaoDone = !!tokenAtivacaoDisponivel && !!(wabaIdSalvo || consultaTemplatesForm.wabaId);
  const etapaSelecaoDone = !!consultaTemplatesForm.selectedTemplateKey && !!consultaTemplatesForm.to;
  const etapaParametrosDone = (quantidadeParametrosEsperada || 0) === 0
    ? true
    : bodyPreenchidos === Number(quantidadeParametrosEsperada || 0);
  const etapaOrderDone = !hasOrderDetailsButton
    || (
      String(consultaTemplatesForm.orderReferenceId || '').trim()
      && String(consultaTemplatesForm.orderTotalAmount || '').trim()
      && String(consultaTemplatesForm.orderPaymentLink || '').trim()
    );

  const templateInfoSelecionado = {
    nome: templateSelecionado?.name || '-',
    idioma: templateSelecionado?.language || '-',
    status: templateSelecionado?.status || '-',
    categoria: templateSelecionado?.category || '-',
    id: templateSelecionado?.id || '-'
  };

  function extrairPlaceholdersDoTexto(texto) {
    return [...String(texto || '').matchAll(/\{\{\s*([^{}]+?)\s*\}\}/g)]
      .map((item) => String(item?.[1] || '').trim())
      .filter(Boolean);
  }

  const placeholdersTemplate = componentesTemplate.flatMap((component) => extrairPlaceholdersDoTexto(component?.text));
  const placeholdersNomeados = placeholdersTemplate.filter((token) => !/^\d+$/.test(token));
  const placeholdersNumericos = placeholdersTemplate.filter((token) => /^\d+$/.test(token));

  const placeholdersNormalizados = placeholdersNomeados
    .map((token) => token
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, ''));

  const templateTemPlaceholderDescricao = placeholdersNormalizados.some((token) => (
    token.includes('product_name')
    || token.includes('description')
    || token.includes('item_name')
    || token.includes('produto')
  ));

  const templateTemPlaceholderOrderNumber = placeholdersNormalizados.some((token) => (
    token.includes('order_number')
    || token.includes('order_no')
    || token.includes('order_id')
    || token.includes('charge')
    || token.includes('pedido')
  ));

  const templateTemPlaceholderQuantidade = placeholdersNormalizados.some((token) => (
    token.includes('quantity')
    || token.includes('qty')
    || token.includes('quantidade')
  ));

  const diagnosticoTemplate = {
    suportaImagemHeader: hasHeaderImageTemplate,
    possuiOrderDetails: hasOrderDetailsButton,
    possuiPlaceholderOrderNumber: templateTemPlaceholderOrderNumber,
    possuiPlaceholderDescricao: templateTemPlaceholderDescricao,
    possuiPlaceholderQuantidade: templateTemPlaceholderQuantidade,
    possuiPlaceholdersNumericos: placeholdersNumericos.length > 0
  };

  const exibirCampoParametrosTemplate = (quantidadeParametrosEsperada || 0) > 0;
  const exibirCampoOrderNumber = hasOrderDetailsButton && diagnosticoTemplate.possuiPlaceholderOrderNumber;
  const exibirCampoDescricaoProduto = hasOrderDetailsButton && diagnosticoTemplate.possuiPlaceholderDescricao;
  const exibirCampoQuantidadeProduto = hasOrderDetailsButton && diagnosticoTemplate.possuiPlaceholderQuantidade;
  const exibirCampoTotalProduto = hasOrderDetailsButton;
  const exibirCampoImagemPublica = hasHeaderImageTemplate;
  const exibirBlocoCamposTemplate = hasOrderDetailsButton || exibirCampoImagemPublica;

  return (
    <S.templateTestBox>
      <h4>Templates Oficiais</h4>

      <S.templateWorkbench>
        <S.templatePane>
          <S.templateStage>
            <S.stageHeader>
              <h5>Etapa 1 - Conexao e Busca</h5>
              <S.stageStatus done={etapaConexaoDone}> {etapaConexaoDone ? 'Concluida' : 'Pendente'} </S.stageStatus>
            </S.stageHeader>
            <p>Configure o WABA e atualize a lista de templates.</p>

            {!wabaIdSalvo && (
              <S.formGrid>
                <label>
                  WABA ID *
                  <input
                    type='text'
                    placeholder='Ex: 123456789012345'
                    value={consultaTemplatesForm.wabaId}
                    onChange={(e) => handleConsultaTemplatesField('wabaId', e.target.value)}
                  />
                </label>

                <label>
                  Limite
                  <input
                    type='number'
                    min='1'
                    max='500'
                    value={consultaTemplatesForm.limit}
                    onChange={(e) => handleConsultaTemplatesField('limit', e.target.value)}
                  />
                </label>
              </S.formGrid>
            )}

            <S.templateActions>
              <button
                type='button'
                className='primary'
                onClick={buscarTodosTemplates}
                disabled={loading || consultaTemplatesLoading || !tokenAtivacaoDisponivel}
              >
                {consultaTemplatesLoading ? 'Buscando...' : 'Atualizar Templates'}
              </button>
            </S.templateActions>

            <div style={{ marginTop: '8px', fontSize: '12px', color: '#a7b8af' }}>
              Token: <strong>{tokenAtivacaoDisponivel ? 'Disponivel' : 'Nao encontrado'}</strong> | Teste inicial: <strong>{testeEnvioConcluido ? 'Concluido' : 'Pendente'}</strong> | WABA salvo: <strong>{wabaIdSalvo || 'Nao salvo'}</strong>
            </div>

            {consultaTemplatesMessage.text && (
              <S.feedback type={consultaTemplatesMessage.type}>{consultaTemplatesMessage.text}</S.feedback>
            )}
          </S.templateStage>

          {!!consultaTemplates.length && (
            <>
              <S.templateStage>
                <S.stageHeader>
                  <h5>Etapa 2 - Template e Destino</h5>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    {!!consultaTemplatesForm.selectedTemplateKey && (
                      <button
                        type='button'
                        onClick={() => setMostrarInfoTemplate((prev) => !prev)}
                        aria-label='Mostrar detalhes do template selecionado'
                        title='Mostrar detalhes do template selecionado'
                        style={{
                          width: '26px',
                          height: '26px',
                          borderRadius: '50%',
                          border: '1px solid #3d4e46',
                          background: 'transparent',
                          color: '#b8c8bf',
                          fontWeight: 700,
                          cursor: 'pointer'
                        }}
                      >
                        i
                      </button>
                    )}
                    <S.stageStatus done={etapaSelecaoDone}> {etapaSelecaoDone ? 'Concluida' : 'Pendente'} </S.stageStatus>
                  </div>
                </S.stageHeader>
                <p>Escolha o template e informe o numero de destino.</p>

                <S.formGrid>
                  <label>
                    Template para envio
                    <select
                      value={consultaTemplatesForm.selectedTemplateKey}
                      onChange={(e) => handleConsultaTemplatesField('selectedTemplateKey', e.target.value)}
                    >
                      <option value=''>Selecione</option>
                      {consultaTemplates.map((template) => {
                        const key = `${template.name || ''}::${template.language || ''}`;
                        return (
                          <option key={template.id || key} value={key}>
                            {template.name} ({template.language})
                          </option>
                        );
                      })}
                    </select>
                  </label>

                  <label>
                    Numero destino (com DDI, sem +)
                    <input
                      type='text'
                      placeholder='5511999999999'
                      value={consultaTemplatesForm.to}
                      onChange={(e) => handleConsultaTemplatesField('to', e.target.value)}
                    />
                  </label>
                </S.formGrid>

                {!!consultaTemplatesForm.selectedTemplateKey && mostrarInfoTemplate && (
                  <S.infoBox style={{ marginTop: '10px' }}>
                    <p><strong>Template selecionado</strong></p>
                    <p>Nome: {templateInfoSelecionado.nome}</p>
                    <p>Idioma: {templateInfoSelecionado.idioma}</p>
                    <p>Status: {templateInfoSelecionado.status}</p>
                    <p>Categoria: {templateInfoSelecionado.categoria}</p>
                    <p>ID: {templateInfoSelecionado.id}</p>
                  </S.infoBox>
                )}
              </S.templateStage>

              <S.templateStage>
                <S.stageHeader>
                  <h5>Etapa 3 - Parametros do Conteudo</h5>
                  <S.stageStatus done={etapaParametrosDone && etapaOrderDone}> {(etapaParametrosDone && etapaOrderDone) ? 'Concluida' : 'Pendente'} </S.stageStatus>
                </S.stageHeader>
                <p>Preencha os dados de texto e, se houver, os dados do pedido.</p>

                {exibirCampoParametrosTemplate && (
                  <S.formGrid>
                    <label>
                      Parametros do template (separar por |)
                      <input
                        type='text'
                        placeholder='valor 1|valor 2|valor 3'
                        value={consultaTemplatesForm.bodyParams || ''}
                        onChange={(e) => handleConsultaTemplatesField('bodyParams', e.target.value)}
                      />
                      <small>Esperados: {quantidadeParametrosEsperada || 0} | Preenchidos: {bodyPreenchidos}</small>
                    </label>
                  </S.formGrid>
                )}

                {exibirBlocoCamposTemplate && (
                  <S.formGrid>
                    {hasOrderDetailsButton && (
                      <label>
                        Referencia do pedido
                        <input
                          type='text'
                          placeholder='pedido_12345'
                          value={consultaTemplatesForm.orderReferenceId || ''}
                          onChange={(e) => handleConsultaTemplatesField('orderReferenceId', e.target.value)}
                        />
                      </label>
                    )}

                    {exibirCampoOrderNumber && (
                      <label>
                        {'Order number ({{Order number}})'}
                        <input
                          type='text'
                          placeholder='ORD-2026-0001'
                          value={consultaTemplatesForm.orderNumber || ''}
                          onChange={(e) => handleConsultaTemplatesField('orderNumber', e.target.value)}
                        />
                      </label>
                    )}

                    {exibirCampoDescricaoProduto && (
                      <label>
                        {'Product name ({{Product name}})'}
                        <input
                          type='text'
                          placeholder='Nome do produto'
                          value={consultaTemplatesForm.productName || ''}
                          onChange={(e) => handleConsultaTemplatesField('productName', e.target.value)}
                        />
                      </label>
                    )}

                    {exibirCampoQuantidadeProduto && (
                      <label>
                        {'Quantity ({{#}})'}
                        <input
                          type='text'
                          placeholder='1'
                          value={consultaTemplatesForm.productQuantity || ''}
                          onChange={(e) => handleConsultaTemplatesField('productQuantity', e.target.value)}
                        />
                      </label>
                    )}

                    {exibirCampoTotalProduto && (
                      <label>
                        Valor total do pedido (ex: 125,32)
                        <input
                          type='text'
                          placeholder='125,32'
                          value={consultaTemplatesForm.orderTotalAmount || ''}
                          onChange={(e) => handleConsultaTemplatesField('orderTotalAmount', e.target.value)}
                        />
                      </label>
                    )}

                    {hasOrderDetailsButton && (
                      <label>
                        Tipo do pedido
                        <select
                          value={consultaTemplatesForm.orderType || 'digital-goods'}
                          onChange={(e) => handleConsultaTemplatesField('orderType', e.target.value)}
                        >
                          <option value='digital-goods'>digital-goods</option>
                          <option value='physical-goods'>physical-goods</option>
                        </select>
                      </label>
                    )}

                    {hasOrderDetailsButton && (
                      <label>
                        Link de pagamento
                        <input
                          type='text'
                          placeholder='https://...'
                          value={consultaTemplatesForm.orderPaymentLink || ''}
                          onChange={(e) => handleConsultaTemplatesField('orderPaymentLink', e.target.value)}
                        />
                      </label>
                    )}

                    {exibirCampoImagemPublica && (
                      <label>
                        URL publica da imagem (envio oficial)
                        <input
                          type='text'
                          placeholder='https://seu-dominio.com/imagem-produto.jpg'
                          value={consultaTemplatesForm.productImagePublicUrl || ''}
                          onChange={(e) => handleConsultaTemplatesField('productImagePublicUrl', e.target.value)}
                        />
                        <small>
                          Obrigatoria para envio quando o template tiver HEADER IMAGE.
                        </small>
                      </label>
                    )}

                  </S.formGrid>
                )}
              </S.templateStage>

              <S.templateStage>
                <S.stageHeader>
                  <h5>Etapa 4 - Envio</h5>
                  <S.stageStatus done={false}>Acao</S.stageStatus>
                </S.stageHeader>

                {!!consultaTemplatesForm.selectedTemplateKey && (
                  <S.templateActions>
                    <button
                      type='button'
                      className='primary'
                      onClick={enviarTemplateSelecionado}
                      disabled={loading || envioTemplateLoading}
                    >
                      {envioTemplateLoading
                        ? 'Enviando...'
                        : testeEnvioConcluido
                          ? 'Enviar Template (Normal)'
                          : 'Enviar Primeiro Teste'}
                    </button>
                  </S.templateActions>
                )}

                {envioTemplateMessage.text && (
                  <S.feedback type={envioTemplateMessage.type}>{envioTemplateMessage.text}</S.feedback>
                )}
              </S.templateStage>
            </>
          )}
        </S.templatePane>

        <S.templatePreviewShell>
          <p style={{ margin: 0 }}><strong>Preview WhatsApp</strong></p>
          <p style={{ margin: '4px 0 0 0', color: '#9fb0a6', fontSize: '12px' }}>
            Visao final da mensagem para o template selecionado.
          </p>
          <div
            style={{
              marginTop: '8px',
              borderRadius: '8px',
              border: '1px solid #3b4a43',
              background: 'rgba(59, 74, 67, 0.24)',
              color: '#c3d2ca',
              fontSize: '11px',
              padding: '8px 10px'
            }}
          >
            Campos de pedido alimentam os parametros do template no envio.
            {hasHeaderImageTemplate && !previewProductImagePublicUrl && (
              <span style={{ display: 'block', marginTop: '6px', color: '#ffd08a' }}>
                Template com HEADER IMAGE detectado: informe URL publica da imagem para ela chegar no destinatario.
              </span>
            )}
          </div>

          <div
            style={{
              marginTop: '10px',
              borderRadius: '14px',
              padding: 'clamp(8px, 2vw, 14px)',
              background: 'radial-gradient(circle at 20% 20%, #2f3f35 0, #1c2822 38%, #121914 100%)',
              border: '1px solid #2f3f35'
            }}
          >
            <div
              style={{
                width: '100%',
                maxWidth: '430px',
                margin: '0 auto',
                background: '#0f1f1c',
                borderRadius: 'clamp(18px, 3.4vw, 28px)',
                border: 'clamp(4px, 1.2vw, 8px) solid #0b0f0e',
                boxShadow: '0 12px 30px rgba(0, 0, 0, 0.38)',
                overflow: 'hidden'
              }}
            >
              <div style={{ height: 'clamp(20px, 4vw, 26px)', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0b0f0e' }}>
                <div style={{ width: 'clamp(78px, 20vw, 110px)', height: '4px', borderRadius: '999px', background: '#2c3a35' }} />
              </div>

              <div style={{ background: '#0f6e64', padding: '10px 12px', color: '#e8f7ef', fontSize: 'clamp(11px, 2.3vw, 13px)' }}>
                <strong style={{ fontWeight: 600 }}>RBento Assistente</strong>
              </div>

              <div
                style={{
                  padding: '12px 10px',
                  backgroundColor: '#e6ddd1',
                  backgroundImage: 'radial-gradient(rgba(0,0,0,0.03) 1px, transparent 1px)',
                  backgroundSize: '14px 14px'
                }}
              >
                <div
                  style={{
                    width: '100%',
                    background: '#ffffff',
                    borderRadius: '8px',
                    boxShadow: '0 1px 1px rgba(0,0,0,0.15)',
                    overflow: 'hidden'
                  }}
                >
                  {hasOrderDetailsButton && (
                    <div style={{ background: '#ffffff', padding: '10px 12px 8px 12px', borderBottom: '1px solid #d8d8d8' }}>
                      <div style={{ fontSize: 'clamp(10px, 2vw, 11px)', letterSpacing: '1px', color: '#6a6a6a', marginBottom: '6px' }}>
                        CHARGE #{previewOrderNumber}
                      </div>
                      <div style={{ borderTop: '1px dashed #cfcfcf', marginBottom: '8px' }} />
                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        <div
                          style={{
                            width: 'clamp(36px, 8.5vw, 44px)',
                            height: 'clamp(36px, 8.5vw, 44px)',
                            borderRadius: '8px',
                            background: '#aeb4bb',
                            overflow: 'hidden',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#fff'
                          }}
                        >
                          {previewProductImagePublicUrl
                            ? <img src={previewProductImagePublicUrl} alt='produto' style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                            : <span style={{ fontSize: '18px' }}>▣</span>}
                        </div>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 'clamp(13px, 3.3vw, 16px)', color: '#1a1a1a', fontWeight: 600 }}>{previewProductName}</div>
                          <div style={{ fontSize: 'clamp(11px, 2.6vw, 13px)', color: '#676767' }}>Quantity {previewProductQuantity}</div>
                        </div>
                      </div>
                      <div style={{ borderTop: '1px dashed #cfcfcf', margin: '8px 0 6px 0' }} />
                      <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 'clamp(14px, 3.8vw, 18px)', fontWeight: 700, color: '#212121' }}>
                        <span>Total</span>
                        <span>R$ {previewTotalPedido}</span>
                      </div>
                    </div>
                  )}

                  <div style={{ padding: '12px 12px 8px 12px', color: '#202124', background: '#ffffff' }}>
                    {previewHeaderText && (
                      <div style={{ fontSize: 'clamp(18px, 5vw, 34px)', lineHeight: 1.02, fontWeight: 800, marginBottom: '8px' }}>
                        {previewHeaderText}
                      </div>
                    )}

                    {previewBodyText
                      ? previewBodyText.split('\n').map((linha, index) => (
                        <div key={`linha_preview_${index}`} style={{ fontSize: 'clamp(14px, 4.8vw, 33px)', lineHeight: 1.18 }}>
                          {linha || '\u00A0'}
                        </div>
                      ))
                      : <div style={{ fontSize: '14px' }}>Selecione um template para visualizar.</div>}

                    {previewFooterText && (
                      <div style={{ marginTop: '6px', fontSize: '12px', color: '#5f5f5f' }}>
                        {previewFooterText}
                      </div>
                    )}

                    <div style={{ marginTop: '4px', textAlign: 'right', fontSize: '11px', color: '#7a7a7a' }}>{previewHora}</div>
                  </div>

                  {hasOrderDetailsButton && (
                    <button
                      type='button'
                      disabled
                      style={{
                        width: '100%',
                        border: 0,
                        borderTop: '1px solid #e3e3e3',
                        background: '#ffffff',
                        color: '#1a8f7a',
                        padding: 'clamp(10px, 2.8vw, 12px) 10px',
                        fontSize: 'clamp(15px, 4.5vw, 31px)',
                        fontWeight: 500,
                        cursor: 'not-allowed'
                      }}
                    >
                      {previewBotaoTexto}
                    </button>
                  )}
                </div>
              </div>
            </div>
          </div>
        </S.templatePreviewShell>
      </S.templateWorkbench>
    </S.templateTestBox>
  );
}
